/*** IMPORTS FROM imports-loader ***/
var widgetFactory = require("src/select");

var registerCustomElement = require('@dojo/framework/core/registerCustomElement').default;

var defaultExport = widgetFactory.default;
defaultExport && registerCustomElement(defaultExport);

